import SuccessIcon from 'assets/icons/sz/ok.svg';
import { SZ_CASH_URL, SZ_MAIN_URL } from 'constants/sz';
import { useAppSelector } from 'store/hooks';
import { ButtonKinds } from 'types/button';
import { costFormatWithCurrency, transformDateMoment } from 'utils';

import { BaseCardSZ } from '../ui';
import { Button } from '../ui/button';

const CheckSuccess = () => {
  const { paymentData, amount, isPayment } = useAppSelector((state) => state.payment);

  const amountToFormat = Math.abs(
    paymentData?.fix
      ? Number(paymentData?.fullAmount) || Number(paymentData?.amount)
      : Number(amount),
  );

  return (
    <BaseCardSZ>
      <div className="flex flex-col justify-between">
        <div className="bg-white">
          <div className="p-4 md:p-6 text-center text-base leading-4 font-bold text-sz-black border-b border-b-sz-gray-400">
            <div className="flex items-center gap-[10px] leading-4 justify-center">
              <img src={SuccessIcon} className="w-6 h-6" alt="success" />
              <span>{isPayment ? 'Ваш платеж принят' : 'Выплата прошла успешно'}</span>
            </div>
            <div className="text-sm font-medium mt-4">Для обновления баланса зайдите в кошелек</div>
          </div>
          <div className="p-4 md:p-6 text-base leading-4 font-medium text-sz-black border-b border-b-sz-gray-400 flex flex-col gap-6">
            <dl className="flex justify-between">
              <dt>Номер транзакции:</dt>
              <dd>{paymentData?.ID}</dd>
            </dl>
            <dl className="flex justify-between">
              <dt>{isPayment ? 'Дата платежа' : 'Дата выплаты'}:</dt>
              <dd>{paymentData?.date && transformDateMoment(paymentData?.date)}</dd>
            </dl>
            <dl className="flex justify-between">
              <dt>{isPayment ? 'Сумма платежа' : 'Сумма выплаты'}:</dt>
              <dd>
                {isPayment
                  ? costFormatWithCurrency(Math.abs(Number(paymentData?.amount)))
                  : costFormatWithCurrency(amountToFormat)}
              </dd>
            </dl>
            {isPayment && (
              <dl className="flex justify-between">
                <dt>Сумма к зачислению:</dt>
                <dd>{costFormatWithCurrency(Math.abs(Number(paymentData?.amount)))}</dd>
              </dl>
            )}
          </div>
        </div>

        <div className="p-4 md:p-6 flex flex-col gap-3 mt-12 md:mt-0">
          <Button href={SZ_MAIN_URL}>К лотереям</Button>
          <Button kind={ButtonKinds.secondary} href={SZ_CASH_URL}>
            В кошелек
          </Button>
        </div>
      </div>
    </BaseCardSZ>
  );
};

export { CheckSuccess };
